import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { makeStyles, Button, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    // Button styles
    buttonDisabled: {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'default',
      pointerEvents: 'none',
    },
    buttonRoot: {
      border: '2px solid transparent',
      borderRadius: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(14),
      padding: theme.spacing(1.5),
      margin: theme.spacing(0.25, 1.75),
    },
    buttonTextPrimary: {
      '&:hover': {
        backgroundColor: 'rgba(0, 113, 219, 0.08)',
        border: '2px solid black',
        outlineOffset: '-2px',
      },
    },
    buttonFocusVisible: {
      backgroundColor: 'rgba(0, 113, 219, 0.08)',
      border: '2px solid black',
      outlineOffset: '-2px',
    },

    // CircularProgress styles
    circleColorPrimary: {
      color: theme.palette.text.disabled,
    },
  };
});

const LoadingButton = ({ children, isLoading, onClick, ...props }) => {
  const classes = useStyles();

  return (
    <Button
      centerRipple
      classes={{
        root: classes.buttonRoot,
        textPrimary: classes.buttonTextPrimary,
        focusVisible: classes.buttonFocusVisible,
      }}
      color="primary"
      aria-disabled={isLoading}
      focusRipple={false}
      onClick={isLoading ? () => {} : onClick}
      size="medium"
      startIcon={
        isLoading && (
          <CircularProgress
            aria-label="loading"
            classes={{ colorPrimary: classes.circleColorPrimary }}
            style={{ width: '20px', height: '20px' }}
          />
        )
      }
      {...(isLoading ? { className: classes.buttonDisabled } : {})}
      {...props}
    >
      {children}
    </Button>
  );
};

LoadingButton.propTypes = {
  /**
   * The contents (typically text) displayed on the button.
   */
  children: PropTypes.node,
  /**
   * Should the button show the loading state.
   */
  isLoading: PropTypes.bool,
  /**
   * onClick action.
   */
  onClick: PropTypes.func,
};

export default memo(LoadingButton);
